import { RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";

// 入金入力登録リクエスト
export type B030050CreateRequest = {
  nyukinYmd: string;
  seikyuCd: string;
  seikyushitenCd: string;
  // 明細
  nyukinmeiList: B030050CreateMeiRequest[];
} & Partial<{
  nyukindenpyoNo: string;
  shainCd: string;
  bumonCd: string;
  bikoCd: string;
  biko: string;
}>;

export type B030050CreateMeiRequest = {
  gyoNo: string;
  uchiwakeKbn: string;
  nyuKin: string;
} & Partial<{
  ginkoCd: string;
  tegatabango: string;
  tegatashubetsuKbn: string;
  tegatafuridashiYmd: string;
  tegatakesaiYmd: string;
  tegatasaito: string;
  meisaibikoCd: string;
  meisaibiko: string;
}>;

export type B030050CreateResponse = {
  nyukindenpyoNo: string;
};

// 入金入力登録処理
export const B030050Create = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // 明細マッピング
  const meiData: B030050CreateMeiRequest[] = rows.map((row: any) => {
    return row;
  });

  // ヘッダー
  const data: B030050CreateRequest = {
    nyukindenpyoNo: fields.nyukindenpyoNo,
    nyukinYmd: fields.nyukinYmd,
    seikyuCd: fields.seikyuCd,
    seikyushitenCd: fields.seikyushitenCd,
    shainCd: fields.shainCd,
    bumonCd: fields.bumonCd,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    // 明細
    nyukinmeiList: [...meiData],
  };

  return RestClient.post<B030050CreateResponse>("b030050/create", data);
};

// 入金入力検索リクエスト
export type B030050FindRequest = {
  nyukindenpyoNo: string;
} & Partial<{
  page: number;
  sort: string[];
  size: number;
}>;

// 入金入力検索レスポンス
export type B030050FindResponse = {
  nyukindenpyoNo: string;
  nyukinYmd: string;
  seikyuCd: string;
  seikyushitenCd: string;
  seikyuNmr: string;
  shainCd: string;
  shainNm: string;
  bumonCd: string;
  bumonNm: string;
  bikoCd: string;
  biko: string;
  seikyushimeYmd: string;
  seikyushimeNo: string;
  version: string;
  gyoNo: string;
  uchiwakeKbn: string;
  nyuKin: string;
  ginkoCd: string;
  ginkoNm: string;
  shitenNm: string;
  tegatabango: string;
  tegatashubetsuKbn: string;
  tegatafuridashiYmd: string;
  tegatakesaiYmd: string;
  tegatasaito: string;
  meisaibikoCd: string;
  meisaibiko: string;
};

// 入金入力検索処理
export const B030050Find = (props: B030050FindRequest) => {
  return RestClient.get<B030050FindResponse[]>("b030050/find", {
    params: props,
  });
};

// 入金入力更新リクエスト
export type B030050UpdateRequest = {
  nyukindenpyoNo: string;
  nyukinYmd: string;
  seikyuCd: string;
  seikyushitenCd: string;
  nyukinmeiList: B030050UpdateMeiRequest[];
  version: string;
} & Partial<{
  shainCd: string;
  bumonCd: string;
  bikoCd: string;
  biko: string;
  seikyushimeYmd: string;
  seikyushimeNo: string;
}>;

export type B030050UpdateMeiRequest = {
  gyoNo: string;
  uchiwakeKbn: string;
  nyuKin: string;
} & Partial<{
  ginkoCd: string;
  tegatabango: string;
  tegatashubetsuKbn: string;
  tegatafuridashiYmd: string;
  tegatakesaiYmd: string;
  tegatasaito: string;
  meisaibikoCd: string;
  meisaibiko: string;
}>;

// 入金入力更新処理
export const B030050Update = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // 明細マッピング
  const meiData: B030050UpdateMeiRequest[] = rows.map((row: any) => {
    return row;
  });

  // ヘッダー
  const data: B030050UpdateRequest = {
    nyukindenpyoNo: fields.nyukindenpyoNo,
    nyukinYmd: fields.nyukinYmd,
    seikyuCd: fields.seikyuCd,
    seikyushitenCd: fields.seikyushitenCd,
    shainCd: fields.shainCd,
    bumonCd: fields.bumonCd,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    seikyushimeYmd: fields.seikyushimeYmd,
    seikyushimeNo: fields.seikyushimeNo,
    version: fields.version,
    nyukinmeiList: [...meiData],
  };

  return RestClient.put("b030050/update", data);
};

// 入金入力削除リクエスト
export type B030050DeleteRequest = {
  nyukindenpyoNo: string;
};

// 入金入力削除処理
export const B030050Delete = (props: B030050DeleteRequest) => {
  return RestClient.delete("b030050/delete", { data: props });
};
